export * from './progress-indicator-slider.module';